<template>
  <div>
    Approval is {{state}}
    <small>{{smallText}}</small>

    <p v-if="approvalMode != 'none' && approvalSettings.approverDesignation === 'chooseOnCheckout'">
      Approving admin will be chosen when ordering
    </p>

    <p v-if="approvalMode != 'none' && approvalSettings.approvalByGroup">Approving admin filtered by groups</p>
  </div>
</template>

<style scoped>
small {
  display: block;
}
p {
  margin: 0.5em 0 0 0;
}
</style>

<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters(['approvalSettings']),
    approvalMode() {
      return this.approvalSettings.approvalMode || 'none';
    },
    state() {
      return {none: 'OFF', review: 'ON', payment: 'ON'}[this.approvalMode];
    },
    smallText() {
      return {
        none: 'Orders will be sent to production automatically',
        review: 'An admin will need to review all orders',
        payment: 'An admin will need to review+enter billing for all orders'
      }[this.approvalMode];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/ViewApproval.vue